import { WeekDay } from '@angular/common';

export class WeeklySchedule {
    public daysOfWeek: WeekDay[];
    public beginTime: Date;
    public endTime: Date;
}